<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Spesa Extra</span>
                    <!--  class="sa-flexbox-body-title" -->
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" v-if="!isViewMode" @click="onClickNuovaSpesaExtra" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                    <b-button size="sm" variant="outline-purple outline-primary-noborder  sa-margin-right float-sm-right" @click="onClickStampa()">
                        <b-icon icon="printer" />
                        Stampa
                    </b-button>

                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table sa-card-border">
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>

                        <template #cell(importo)="item"> {{ item.item.importo }}€ </template>
                        <template #cell(imponibile)="item"> {{ item.item.imponibile }}€ </template>
                        <template #cell(quotaIva)="item"> {{ (item.item.importo - item.item.imponibile).toFixed(2) }}€ </template>
                        <template #cell(totale)="item"> {{ item.item.totale }}€</template>

                        <template #cell(statoAttuale)="item">
                            <b-badge :variant="getStatusVariant(item.item.statoAttuale)">
                                {{ item.item.statoAttuale }}
                            </b-badge>
                        </template>
                        <!-- -->
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row" v-if="!isViewMode">
                                <!--    <print-component :data="null" :linkPrintData="linkPrintData(item)" typeButton="small"></print-component> -->
                                <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Spesa" @click="onClickAggiornaSpesaExtra(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Spesa" variant="outline-danger" @click="onDeleteSpesaExtra(item)" v-if="item.statoAttuale != 'CONCLUSO'">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>

                                <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Concludi Spesa" @click="onClickConcludiSpesa(item)" v-if="checkIfSpesaRicorsiva(item)">
                                    <!--  <i class="fas fa-clock"></i> -->
                                    <font-awesome-icon :icon="['fas', 'clock']" />
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>

                <rsa-spesa-extra-edit ref="cmpRsaSpesaExtraEditComponent" :json-data-accettazione="jsonDataAccettazione" :id-accettazione="idAccettazione" @onSave="loadData" @closeModal="loadData" @deleteSpesaExtra="loadData"> </rsa-spesa-extra-edit>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <print-component v-show="false" ref="cmpPrint"></print-component>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaSpesaExtraEdit from "./RsaSpesaExtraEditComponent.vue";
import moment from "moment";
import PrintComponent from "../../../utility/components/PrintComponent.vue";

export default {
    props: {
        jsonDataAccettazione: { type: Object },
        utente: { type: Object },
        isViewMode: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
        /* idAccettazione: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.loadData();
                }
            },
        }, */
    },
    mixins: [UtilityMixin],
    components: { RsaSpesaExtraEdit, PrintComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            pathResource: "/rsaspeseextrapazienti",
            /* pathResourceSpesaExtra: "/rsaspeseextra", */
            linkedit: "/",
            idAccettazione: null,
            /* idSpeseExtra: [], */
            filterItems: [],
            filtroSpesaExtra: {},
            showModalLoading: false,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Spesa",
                    key: "spesaExtra",
                },
                {
                    label: "Imponibile",
                    key: "imponibile",
                },
                {
                    label: "Quota IVA(€)",
                    key: "quotaIva",
                },
                {
                    label: "Data Inizio",
                    key: "dataOraInizio",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY");
                        } else {
                            return "-----";
                        }
                    },
                },
                {
                    label: "Data Fine",
                    key: "dataOraFine",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY");
                        } else {
                            return "-----";
                        }
                    },
                },
                {
                    label: "Importo",
                    key: "importo",
                    sortable: true,
                },
                {
                    label: "Totale",
                    key: "totale",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                    thStyle: () => (this.isViewMode ? "display: none" : ""),
                    /* thStyle: function() {
                    return this.isViewMode ? 'display: none' : '';
                    } */
                },
            ],
        };
    },
    mounted() {},

    methods: {
        setId(id) {
            let me = this;
            me.idAccettazione = id;
            me.filtroSpesaExtra = { idAccettazione: id };
            me.loadData();
        },
        /*   loadSpeseExtra() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSpesaExtra, null, me.loadSpeseExtraSuccess, me.loadSpeseExtraError);
        },

        loadSpeseExtraSuccess(response) {
            let me = this;
            me.idSpeseExtra = response.data.data.list;
        },
        loadSpeseExtraError(error) {
            let me = this;
            console.error("Errore caricamento spese extra:", error);
            me.$bvToast.toast("Errore nel caricamento delle spese extra", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        }, */

        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.$emit("beforeLoadData");
            if (!me.idAccettazione) {
                console.warn("Non carica il load data: idAccettazione non disponibile");
                return;
            }
            if (sessionStorage["filtroSpesaExtra"]) {
                me.filtroSpesaExtra = JSON.parse(sessionStorage["filtroSpesaExtra"]);
            }
            me.filtroSpesaExtra = {
                ...me.filtroSpesaExtra,
                page: me.currentPage,
                forPage: me.perPage,
                idAccettazione: me.idAccettazione,
            };
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroSpesaExtra, me.loadDataSuccess, me.loadDataError);
        },

        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.$bvToast.toast("Errore durante il caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        onClickAggiornaSpesaExtra(item) {
            let me = this;
            me.$refs.cmpRsaSpesaExtraEditComponent.aggiornaSpesaExtraPaziente(item);
        },

        onDeleteSpesaExtra(item) {
            let me = this;
            me.$refs.cmpRsaSpesaExtraEditComponent.onDeleteSpesaExtra(item);
        },

        onClickNuovaSpesaExtra() {
            let me = this;
            console.log("PROVA", this.jsonDataAccettazione);
            if (me.jsonDataAccettazione?.statoAttuale === "DIMESSO" || me.jsonDataAccettazione?.statoAttuale === "TRASFERITO" || me.jsonDataAccettazione?.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "ASSENTE" ? "Non è possibile questa operazione su un paziente assente" : "Non è possibile questa operazione su un paziente dimesso";

                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });

                return;
            } else {
                if (me.idAccettazione) {
                    me.$refs.cmpRsaSpesaExtraEditComponent.nuovaSpesaExtraPaziente(this.idAccettazione);
                } else {
                    me.$bvModal.msgBoxOk("Dati accettazione non disponibili", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                    });
                }
            }
        },

        onClickConcludiSpesa(item) {
            let me = this;
            me.$refs.cmpRsaSpesaExtraEditComponent.concludiSpesaExtraPaziente(item);
        },

        saveSuccessResponse(response) {
            let me = this;
            me.$emit("sucessRestCall", response);
            me.$emit("onAfterSave");
            me.loadData();
        },
        saveErrorResponse(response) {
            console.log(response.response.data);
            let me = this;
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                me.$bvToast.toast("Errore nel salvataggio" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        getStatusVariant(status) {
            switch (status) {
                case "INSERITO":
                    return "secondary";
                case "ANNULLATO":
                    return "danger";
                case "IN ATTESA":
                    return "warning";
                case "CONCLUSO":
                    return "success";
                default:
                    return "secondary";
            }
        },

        checkIfSpesaRicorsiva(item) {
            let me = this;
            if (!item.idSpeseExtra) return false; /* || item.dataOraFine */
            return me.$refs.cmpRsaSpesaExtraEditComponent.isSpesaRicorsiva(item.idSpeseExtra);
        },
        onClickStampa() {
            let me = this;

            me.loadDataResources(me.pathResource + "/printdata/" + me.idAccettazione, null, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampa(error) {
            console.log(error);
        },
    },
};
</script>
